var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnakeGameLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 250,
    height: 250,
    fill: "#29426B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 250,
    height: 250,
    fill: "#171717",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 50,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 50,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 50,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 50,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 100,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 100,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 100,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 100,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 100,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 150,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 150,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 150,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 150,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 150,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 200,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 200,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 200,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 200,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 200,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 250,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 250,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 250,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 250,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 250,
    width: 50,
    height: 50,
    fill: "#171717",
    fillOpacity: 0.01
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 201.5,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "white",
    strokeWidth: 3
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 201.5,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "white",
    strokeWidth: 3
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 151.5,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "white",
    strokeWidth: 3
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 101.5,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "white",
    strokeWidth: 3
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 101.5,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "white",
    strokeWidth: 3
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 51.5,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "white",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 215,
    r: 5,
    fill: "#0099FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 225,
    r: 5,
    fill: "#85E7B1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 238,
    r: 10,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnakeGameLogo);
export default __webpack_public_path__ + "static/media/Snake Game Logo.90a050f80ebb6a20ad553fa427d1108f.svg";
export { ForwardRef as ReactComponent };